// ─────────────────────────────────────────────────────────────────────────────
// 🔑 WHO SEES PROFILE → PAYOUT DETAILS (broker report 1102, Jesse 2026-11-02).
// The panel is for the people who can act on the firm's payout details: whoever GET /me/banking says may edit
// (canEdit — accountBankingAuthority, the rule PATCH /banking enforces), AND the firm's account-level holder who may
// not edit right now, who must be told why and what to do (the server's reason and sentence):
//   · not_payee_contact — the broker of record is not the person set up to manage the details;
//   · contact_archived  — the person set up to manage them is no longer active.
// An ordinary member (not_account_level) and a partner with no firm (no_account) do not see it: the fact reaches them
// on My Tasks, where they can act. 🚨 The panel was gated on canEdit alone, so its "can't edit" sentence could never
// appear — the one state it was written for.
// ─────────────────────────────────────────────────────────────────────────────
export const PAYOUT_PANEL_REFUSALS_SHOWN = ['not_payee_contact', 'contact_archived'];
export const PAYOUT_PANEL_REFUSALS_HIDDEN = ['not_account_level', 'no_account', 'unknown_partner'];

export function showPayoutPanel(banking) {
  if (!banking) return false;
  if (banking.canEdit) return true;
  return PAYOUT_PANEL_REFUSALS_SHOWN.includes(banking.reason);
}
